import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import LogoMark from "./LogoMark";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/reviews", label: "Reviews" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ""}`}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <LogoMark className={styles.logoMark} />
          BOI Gardens &amp; Car Cleaning
        </Link>

        <div className={styles.links}>
          {NAV_LINKS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`${styles.link} ${pathname === item.to ? styles.linkActive : ""}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <Link to="/booking" className={`btn btnPrimary ${styles.cta}`}>
          Book now
        </Link>

        <button
          type="button"
          className={styles.menuBtn}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <svg
            className={styles.menuIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            {menuOpen ? (
              <path d="M6 6l12 12M18 6L6 18" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>
      </div>

      {menuOpen && (
        <div className={styles.mobilePanel}>
          {NAV_LINKS.map((item) => (
            <Link key={item.to} to={item.to} className={styles.mobileLink}>
              {item.label}
            </Link>
          ))}
          <Link to="/booking" className={`btn btnPrimary ${styles.mobileCta}`}>
            Book now
          </Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
